// Sidebar Sign Out — ends the session and drops the user back to /login.

import { LogOut } from 'lucide-react';
import { useState } from 'react';

import { signOut } from '@/lib/auth';
import { cn } from '@/lib/utils';

export default function SignOutButton() {
    const [pending, setPending] = useState(false);

    async function handleClick() {
        if (pending) return;
        setPending(true);
        await signOut();
    }

    return (
        <div>
            <button
                onClick={handleClick}
                disabled={pending}
                className={cn(
                    'w-full flex items-center gap-2 px-2.5 py-2 rounded-[9px]',
                    'text-annotation text-[rgb(var(--color-text-tertiary))]',
                    'hover:text-[rgb(var(--color-text-secondary))] hover:bg-[rgb(var(--color-text-primary)/0.05)]',
                    'transition-colors',
                    'disabled:opacity-50 disabled:cursor-wait',
                )}
            >
                <LogOut className="w-3.5 h-3.5 flex-shrink-0" />
                {pending ? 'Signing out…' : 'Sign out'}
            </button>
        </div>
    );
}
